import * as tslib_1 from "tslib";
import Typography from '../Typography';
import './resetTextStyle';
import styled from 'styled-components';
var Display1 = styled(Typography).attrs({
    type: 'display1',
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject([""], [""]))).withComponent('h3');
var Display2 = Typography.extend.attrs({
    type: 'display2',
})(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject([""], [""]))).withComponent('h3');
var Display3 = Typography.extend.attrs({
    type: 'display3',
})(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject([""], [""]))).withComponent('h2');
var Display4 = Typography.extend.attrs({
    type: 'display4',
})(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject([""], [""]))).withComponent('h1');
var Headline = Typography.extend.attrs({
    type: 'headline',
})(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject([""], [""]))).withComponent('h5');
var Title = Typography.extend.attrs({
    type: 'title',
})(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject([""], [""]))).withComponent('h5');
var Subheading = Typography.extend.attrs({
    type: 'subheading',
})(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject([""], [""]))).withComponent('h6');
var Body2 = Typography.extend.attrs({
    type: 'body2',
})(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject([""], [""]))).withComponent('p');
var Body1 = Typography.extend.attrs({
    type: 'body1',
})(templateObject_9 || (templateObject_9 = tslib_1.__makeTemplateObject([""], [""]))).withComponent('p');
var Caption = Typography.extend.attrs({
    type: 'caption',
})(templateObject_10 || (templateObject_10 = tslib_1.__makeTemplateObject([""], [""])));
var Button = Typography.extend.attrs({
    type: 'button',
})(templateObject_11 || (templateObject_11 = tslib_1.__makeTemplateObject([""], [""])));
export default Typography;
export { Display4, Display3, Display2, Display1, Headline, Title, Subheading, Body2, Body1, Caption, Button, Display4 as H1, Display3 as H2, Display2 as H3, Display1 as H4, Headline as H5, Subheading as H6, Body1 as P, };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
//# sourceMappingURL=index.js.map